import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const PageMetaContext = createContext({
  title: '',
  subtitle: '',
  setMeta: () => {},
});

export function PageMetaProvider({ children }) {
  const [meta, setMetaState] = useState({ title: '', subtitle: '' });

  const setMeta = useCallback((next) => {
    setMetaState((prev) => {
      const merged = typeof next === 'function' ? next(prev) : { ...prev, ...next };
      if (prev.title === merged.title && prev.subtitle === merged.subtitle) return prev;
      return merged;
    });
  }, []);

  const value = useMemo(() => ({ title: meta.title, subtitle: meta.subtitle, setMeta }), [meta, setMeta]);

  return <PageMetaContext.Provider value={value}>{children}</PageMetaContext.Provider>;
}

export function usePageMetaState() {
  return useContext(PageMetaContext);
}

export function usePageMeta(title, subtitle) {
  const { setMeta } = useContext(PageMetaContext);
  useEffect(() => {
    setMeta({ title, subtitle });
  }, [title, subtitle, setMeta]);
}
